import { createAction } from "redux-actions";

import {
  UPDATE_LUNG,
  GET_LUNG_TOTAL,
  UPDATE_PROSTATE,
  GET_PROSTATE_TOTAL,
  UPDATE_BREAST,
  GET_BREAST_TOTAL,
  UPDATE_THYROID,
  GET_THYROID_TOTAL,
  START_LOADING,
  FINISH_LOADING,
  GET_SERVEY_LIST,
  ADD_SERVEY,
  ADD_TOTAL,
} from "./_actionType";

export const updateLung = ({ datas }) => ({
  type: UPDATE_LUNG,
  payload: {
    datas,
  },
});
export const getSurvey = () => ({
  type: GET_SERVEY_LIST,
});

export const updateProstate = ({ datas }) => ({
  type: UPDATE_PROSTATE,
  payload: {
    datas,
  },
});

export const getLungTotal = (total, lungRe, perCal) => ({
  type: GET_LUNG_TOTAL,
  total: total,
  lungRe: lungRe,
  perCal: perCal,
});

export const getProstateTotal = (total, prostateRe, perCal) => ({
  type: GET_PROSTATE_TOTAL,
  total: total,
  prostateRe: prostateRe,
  perCal: perCal,
});

export const updateBreast = ({ datas }) => ({
  type: UPDATE_BREAST,
  payload: {
    datas,
  },
});

export const getBreastTotal = (total, breastRe, perCal) => ({
  type: GET_BREAST_TOTAL,
  total: total,
  breastRe: breastRe,
  perCal: perCal,
});

export const updateThyroid = ({ datas }) => ({
  type: UPDATE_THYROID,
  payload: {
    datas,
  },
});

export const getThyroidTotal = (total, thyroidRe, perCal) => ({
  type: GET_THYROID_TOTAL,
  total: total,
  thyroidRe: thyroidRe,
  perCal: perCal,
});


export const addServey = ({ datas }) => ({
  type: ADD_SERVEY,
  payload: datas,
});

export const addTotal = ({ datas }) => ({
  type: ADD_TOTAL,
  payload: datas,
});

export const startLoading = createAction(
  START_LOADING,
  (requestType) => requestType
);

export const finishLoading = createAction(
  FINISH_LOADING,
  (requestType) => requestType
);
